import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Logo } from "./Logo";
import { GAMES } from "@/lib/games";

const COLS = [
  { title: "Casino", links: GAMES.map((g) => ({ to: `/games/${g.slug}`, label: g.name })) },
  { title: "Rewards", links: [{ to: "/leaderboard", label: "Weekly Race" }, { to: "/vip", label: "VIP Club" }, { to: "/deposit", label: "Deposit Bonus" }] },
  { title: "Trust", links: [{ to: "/provably-fair", label: "Provably Fair" }, { to: "/dashboard", label: "My Bets" }, { to: "/withdraw", label: "Withdrawals" }] },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-white/[0.06] pt-10 pb-8" data-testid="footer">
      <div className="grid grid-cols-2 md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-3">
            <Logo size="w-10 h-10 text-sm" />
            <div className="font-display font-black tracking-tighter"><span className="gold-text">FMI</span> <span className="text-zinc-500">CASINO</span></div>
          </div>
          <p className="text-xs text-zinc-500 mt-4 max-w-xs leading-relaxed">
            Provably fair crypto casino. Every roll is verifiable with your own seed. Watch-only deposits on BTC, ETH and USDT mainnet, plus testnets for practice.
          </p>
          <div className="flex items-center gap-2 mt-4 text-[10px] uppercase tracking-widest text-zinc-600"><ShieldCheck size={12} className="text-emerald-400" /> SHA-256 · HMAC verified</div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-3">{c.title}</div>
            <ul className="space-y-2">
              {c.links.map((l) => (
                <li key={l.to}><Link to={l.to} className="text-sm text-zinc-400 hover:text-amber-400" style={{ transition: "color 150ms ease" }}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3 mt-10 pt-6 border-t border-white/[0.05] text-[11px] text-zinc-600">
        <span>© 2026 FMI Casino · 18+ · Play responsibly</span>
        <span className="font-mono-num">BTC · ETH · USDT (ERC-20) mainnet · testnet4 / Sepolia</span>
      </div>
    </footer>
  );
}
